export default (theme) => {
  return {
    icon: {
      fontSize: theme.typography.body2.fontSize,
      color: '#ffeb3b',
    },
  }
}
